import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { Keepalive } from '@ng-idle/keepalive';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { BrandingService } from './branding.service';

export enum IdleState {
    NotStarted,
    Started,
    NotIdle,
    Idle,
    Countdown,
    TimedOut
}

@Injectable({
  providedIn: 'root'
})
export class IdleService {
    idleState: IdleState = IdleState.NotStarted;
    warningToast: ActiveToast<any> | undefined;

  constructor(
    private _idle: Idle,
    private _keepalive: Keepalive,
    private _toastr: ToastrService,
    private _authenticationService: AuthenticationService,
    private _brandingService: BrandingService
  ) {
    // TODO: Make these configurable
    // A common setting is 15 to 30 minutes of inactivity. This duration balances security and user convenience.
    const idleTimeout = 900;
    // A common practice is to set the warning to appear 5 minutes before the auto logout.
    const warningTimeout = 300;

    if (this._brandingService.isProgramHub) {
        this._idle.setIdle(idleTimeout);
        this._idle.setTimeout(warningTimeout);
    
        // Set default interrupts (e.g., mouse movements, key presses)
        this._idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    
        this._idle.onIdleEnd.subscribe(() => {
            this.idleState = IdleState.NotIdle;
            this.warningToast?.toastRef?.close();
        });
    
        this._idle.onTimeout.subscribe(() => {
            this.idleState = IdleState.TimedOut;
            this._authenticationService.logout();
        });
    
        this._idle.onIdleStart.subscribe(() => {
            this.idleState = IdleState.Idle;
        });
    
        this._idle.onTimeoutWarning.subscribe((countdown) => {
            if (this.idleState != IdleState.Countdown) {
                this.warningToast = this._toastr.warning('You have been inactive for a while. Your session will expire due to inactivity. Please interact with the page to continue your session.', 'Idle Timeout Warning', {
                    timeOut: warningTimeout * 1000,
                    progressBar: true
                });
            }
            this.idleState = IdleState.Countdown;
        });
    }

    // Keepalive ping interval
    // TODO: Make this configurable
    const keepAliveInterval = 15;
    this._keepalive.interval(keepAliveInterval);
    this._keepalive.onPing.subscribe(async () => {
        await this._authenticationService.refreshAccessToken();
    });

    this.reset();
  }

  reset() {
    this._toastr.clear();
    this._idle.watch();
    this.idleState = IdleState.Started;
  }
}